import {DataGridPageState, GridSort, TicketFilterFormValues} from "@ots-frontend/ots-ui";
import {createAction} from "@reduxjs/toolkit";

export const setTicketPageFilter = createAction<TicketFilterFormValues>("ui/ticket-page/setFilter");
export const setTicketPageStateCell = createAction<[col: number, row: number]>("ui/ticket-page/setStateCell");
export const setTicketPageStateOilCell = createAction<[col: number, row: number]>("ui/ticket-page/setStateOilCell");
export const setTicketPageStateWidths = createAction<(number | undefined)[]>("ui/ticket-page/setStateWidths");
export const setTicketPageStateOilWidths = createAction<(number | undefined)[]>("ui/ticket-page/setStateOilWidths");
export const setTicketPageStateSort = createAction<GridSort | undefined>("ui/ticket-page/setStateSort");
export const setTicketPageStateOilSort = createAction<GridSort | undefined>("ui/ticket-page/setStateOilSort");
